module.exports = __webpack_public_path__ + "static/media/SmallCabinet_After.9030fa83.jpg";